import React from 'react';
import { useProviderAuth } from '@/context/ProviderAuthContext';
import ReviewsSection from '@/components/ReviewsSection';
import { Star } from 'lucide-react';

export default function ProviderReviews() {
  // We don't need 'navigate' or the 'loading' state anymore
  const { provider, token } = useProviderAuth();

  // If the auth context hasn't loaded the provider yet, show the loader
  // This waits for the data without accidentally redirecting you
  if (!provider) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="flex flex-col items-center gap-2">
           <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
           <p className="text-stone-500">Loading reviews...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-6">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-stone-900 flex items-center gap-2">
          <Star className="text-purple-600" size={22} />
          Customer Reviews
        </h2>
        <p className="text-stone-600 mt-1 text-sm">Manage and view your customer reviews</p>
      </div>

      {provider.id && (
        <ReviewsSection 
          userType="provider" 
          userId={provider.id}
          showManagement={true}
          token={token}
        />
      )}
    </div>
  );
}
